import { UploadFilesComponent } from '@app/components/UploadFilesComponent/UploadFilesComponent.main';

export { UploadFilesComponent };
